var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mars-view',{staticClass:"item-wrapper"},[_c('mars-view',{staticClass:"item c-font-normal"},[(_vm.text)?_c('mars-view',{staticClass:"text c-line-clamp1",style:([
        {
            'color': _vm.selected || (_vm.type === 'order' && _vm.direction)
                ? _vm.selectedColor
                : _vm.color,
            'font-weight': _vm.selected || (_vm.type === 'order' && _vm.direction) && _vm.selectedItemBold
                ? 'bold'
                : ''
        }
    ])},[_vm._v("\n    "+_vm._s(_vm.text)+"\n")]):_vm._e(),(_vm.type === 'order')?_c('mars-view',{staticClass:"order-wrapper c-gap-left-small"},[_c('c-triangle',{directives:[{name:"animation",rawName:"v-animation",value:(false),expression:"false"}],staticClass:"order-top",attrs:{"direction":2,"color":_vm.direction === 'up'
                ? _vm.selectedColor
                : _vm.color,"default-line-height":false,"top":"7px"}}),_c('c-triangle',{directives:[{name:"animation",rawName:"v-animation",value:(false),expression:"false"}],staticClass:"order-bottom",attrs:{"direction":1,"color":_vm.direction === 'down'
                ? _vm.selectedColor
                : _vm.color,"default-line-height":false,"top":"7px"}})],1):_c('c-triangle',{staticClass:"c-gap-left-small",attrs:{"direction":_vm.up
            ? 2
            : 1,"color":_vm.selected
            ? _vm.selectedColor
                ? _vm.selectedColor
                : '#333'
            : _vm.color,"top":"10px"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }